var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"energy-label"},[_c('div',{staticClass:"energy-label-arrow",style:(`border-right-color: ${_vm.color}`)}),_c('span',{staticClass:"energy-label-block",style:(`background-color: ${_vm.color}`)},[_c('span',[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }